class BfvForm {
  constructor(options = {}) {
    this.$root = options.element;
    this.$requiredInputs = this.$root.querySelectorAll("[required]");
    this.$legend = this.$root.querySelector(".js-form-required-legend");
    this.$requiredMultiselects = [];
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.showRequiredLegend();
    this.requiredMultiselect();

    if (this.$requiredMultiselects.length > 0) {
      this.watchMultiselectSelection();
    }

    this.preventSubmitIfErrorsExist();
  }

  // toggle legend visibility if there are required fields in the component
  showRequiredLegend() {
    if ([...this.$requiredInputs].length > 0) {
      this.$legend.classList.add("bfv-form__legend--visible");
    }
  }

  requiredMultiselect() {
    this.$requiredMultiselects = this.$root.querySelectorAll(
      ".bfv-multiselect--required",
    );
  }

  checkIfMultiselectIsValidForSubmit() {
    this.$requiredMultiselects.forEach(($multiselect) => {
      const $options = $multiselect.querySelectorAll(
        'option[selected="selected"]',
      ).length;
      if ($options === 0) {
        BfvForm.multiselectErrorHandling($multiselect);
      } else {
        BfvForm.removeError($multiselect);
      }
    });
  }

  watchMultiselectSelection() {
    this.$requiredMultiselects.forEach(($multiselect) => {
      $multiselect.addEventListener("click", () => {
        BfvForm.checkIfOptionIsSelectedAndRemoveError($multiselect);
      });
    });
  }

  preventSubmitIfErrorsExist() {
    this.$root.addEventListener("submit", (event) => {
      if (this.$requiredMultiselects.length > 0) {
        this.checkIfMultiselectIsValidForSubmit();
      } else if (this.$root.querySelector(".input--error")) {
        event.preventDefault();
      }
    });
  }

  static checkIfOptionIsSelectedAndRemoveError($multiselect) {
    const $selectedOptions = $multiselect.querySelectorAll(
      'option[selected="selected"]',
    ).length;
    if ($selectedOptions > 0) {
      BfvForm.removeError($multiselect);
    }
  }

  static removeError($multiselect) {
    BfvForm.checkIfItemHasErrorClassAndRemoveIt($multiselect);
    BfvForm.checkIfItemHasErrorHintAndRemoveIt($multiselect);
  }

  static checkIfItemHasErrorClassAndRemoveIt($multiselect) {
    const $hasError = $multiselect.getElementsByClassName(
      ".bfv-multiselect--error",
    );
    if ($hasError) {
      $multiselect.classList.remove("bfv-multiselect--error");
    }
  }

  static checkIfItemHasErrorHintAndRemoveIt($multiselect) {
    const $hasErrorHint = $multiselect.querySelector(
      ".bfv-multiselect__hint--visible",
    );
    if ($hasErrorHint) {
      $hasErrorHint.classList.remove("bfv-multiselect__hint--visible");
    }
  }

  static multiselectErrorHandling($multiselect) {
    $multiselect.classList.add("bfv-multiselect--error");

    const $hint = $multiselect.querySelector(".bfv-multiselect__hint");
    if ($hint) {
      $hint.classList.add("bfv-multiselect__hint--visible");
    }
    window.event.preventDefault();
  }
}

export default BfvForm;

